<template>
  <v-container>
    <h1 class="mb-2">Reprogramar citas</h1>
    <p>Busca al paciente por su nombre o apellidos para consultar todas sus citas.</p>
    <v-alert v-if="mensaje" :type="error ? 'error' : 'success'">{{ mensaje }}</v-alert>
    <v-card outlined class="mb-6"><v-card-text><v-form @submit.prevent="buscar(1)"><v-row align="center">
      <v-col cols="12" md="9"><v-text-field v-model="texto" label="Nombre del paciente" outlined hide-details clearable /></v-col>
      <v-col cols="12" md="3"><v-btn type="submit" color="primary" :loading="buscando" :disabled="!texto || texto.trim().length < 2">Buscar paciente</v-btn></v-col>
    </v-row></v-form></v-card-text></v-card>
    <v-card v-if="!paciente" outlined>
      <v-card-title>Pacientes encontrados: {{ total }}</v-card-title>
      <v-data-table :headers="patientHeaders" :items="pacientes" item-key="idPaciente" :loading="buscando" hide-default-footer :items-per-page="25" no-data-text="Escribe el nombre del paciente para buscar.">
        <template v-slot:item.acciones="{ item }"><v-btn text color="primary" :loading="cargando === item.idPaciente" :disabled="!!cargando" @click="abrir(item)">Ver todas las citas</v-btn></template>
      </v-data-table>
      <v-pagination v-if="total > 25" :value="pagina" :length="Math.ceil(total / 25)" :disabled="buscando" @input="buscar" class="py-4" />
    </v-card>
    <v-card v-else outlined>
      <v-card-title>{{ paciente.paciente }}<v-spacer/><v-btn text @click="paciente = null">Volver a resultados</v-btn></v-card-title>
      <v-card-text>Historial completo: {{ citas.length }} citas, pasadas y próximas. Selecciona desde cuál deseas modificar el tratamiento. Las citas pasadas son solo de consulta. También se conservan las citas con notas y las canceladas.</v-card-text>
      <v-data-table :headers="headers" :items="citas" item-key="idCita" :items-per-page="-1" hide-default-footer class="historial-citas">
        <template v-slot:item.estado="{ item }">{{ estado(item) }}</template>
        <template v-slot:item.acciones="{ item }"><v-btn small text color="primary" :disabled="item.pasada || item.documentada || item.cancelada" @click="seleccionar(item)">Modificar desde aquí</v-btn></template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialogo" max-width="1100" persistent scrollable><v-card v-if="seleccionada" class="reprogramar-dialog-card">
      <v-card-title class="reprogramar-dialog-title">{{ token ? 'Revisar cambios antes de aceptar' : 'Modificar citas' }} · {{ paciente.paciente }}</v-card-title>
      <v-card-text class="reprogramar-dialog-body">
        <p>Tratamiento / folio {{ seleccionada.idSolicitud }}. Desde la cita del {{ seleccionada.fecha }} a las {{ seleccionada.hora.slice(0,5) }}.</p>
        <v-alert type="info" text>Si cambias la fecha, las citas posteriores de este tratamiento avanzarán cada 7 días. Si solo cambias el terapeuta, se conservan las fechas y horas. Nada se guarda hasta pulsar Aceptar cambios.</v-alert>
        <v-alert v-if="errorDialogo" type="error" text>{{ errorDialogo }}</v-alert>
        <v-row v-if="!token">
          <v-col cols="12" md="4"><v-text-field v-model="fecha" type="date" :min="fechaMinima" label="Nueva fecha" outlined :disabled="guardando" /></v-col>
          <v-col cols="12" md="3"><v-text-field v-model="hora" type="time" label="Hora" outlined :disabled="guardando" /></v-col>
          <v-col cols="12" md="5"><v-autocomplete v-model="terapeuta" :items="terapeutas" item-text="nombre" item-value="idTerapeuta" label="Terapeuta desde esta cita" outlined :disabled="guardando" /></v-col>
        </v-row>
        <h3 class="mb-3">{{ token ? 'Así quedará el historial completo' : 'Todas las citas del paciente' }}</h3>
        <p v-if="token">{{ vista.length }} citas se actualizarán. Las demás conservarán sus datos.</p>
        <v-data-table :headers="previewHeaders" :items="historialVista" :items-per-page="-1" hide-default-footer item-key="idCita" class="historial-citas" :item-class="colorFila">
          <template v-slot:item.antes="{ item }">{{ item.fecha }} · {{ item.hora.slice(0,5) }}<br>{{ item.terapeuta }}</template>
          <template v-slot:item.despues="{ item }"><template v-if="item.cambio">{{ item.cambio.fecha }} · {{ item.cambio.hora.slice(0,5) }}<br>{{ item.cambio.terapeuta }}</template><template v-else>{{ item.fecha }} · {{ item.hora.slice(0,5) }}<br>{{ item.terapeuta }}</template></template>
          <template v-slot:item.estado="{ item }"><v-chip v-if="item.cambio" small color="blue lighten-4">Se actualizará</v-chip><span v-else>{{ estado(item) }}{{ token ? ' · Sin cambios' : '' }}</span></template>
        </v-data-table>
      </v-card-text>
      <v-card-actions class="pa-4 reprogramar-dialog-actions"><v-btn text :disabled="guardando" @click="cancelar">Cancelar</v-btn><v-spacer />
        <v-btn v-if="token" text :disabled="guardando" @click="invalidar">Volver a editar</v-btn>
        <v-btn v-if="!token" color="primary" :loading="guardando" :disabled="!fecha || !hora || !terapeuta" @click="procesar(false)">Revisar cambios</v-btn>
        <v-btn v-else color="primary" :loading="guardando" @click="procesar(true)">Aceptar cambios</v-btn>
      </v-card-actions>
    </v-card></v-dialog>
  </v-container>
</template>
<script>
import api from '@/services/ServiciosApi'
export default {
  name: 'Reprogramar',
  data: () => ({
    fechaMinima: '', texto: '', pacientes: [], paciente: null, citas: [], total: 0, pagina: 1, cargando: null,
    patientHeaders: [{ text: 'Paciente', value: 'paciente' }, { text: 'Identificador', value: 'idPaciente' }, { text: '', value: 'acciones', sortable: false }],
    headers: [{ text: 'Tratamiento / folio', value: 'idSolicitud' }, { text: 'Fecha', value: 'fecha' }, { text: 'Hora', value: 'hora' }, { text: 'Terapeuta', value: 'terapeuta' }, { text: 'Estado', value: 'estado', sortable: false }, { text: '', value: 'acciones', sortable: false }],
    previewHeaders: [{ text: 'Folio', value: 'idSolicitud' }, { text: 'Fecha, hora y terapeuta actuales', value: 'antes', sortable: false }, { text: 'Fecha, hora y terapeuta resultantes', value: 'despues', sortable: false }, { text: 'Estado', value: 'estado', sortable: false }],
    seleccionada: null, dialogo: false, fecha: '', hora: '', terapeuta: null, terapeutas: [],
    vista: [], token: '', buscando: false, guardando: false, mensaje: '', error: false, errorDialogo: ''
  }),
  computed: {
    historialVista() {
      const cambios = new Map(this.vista.map(c => [c.idCita, c]))
      return this.citas.map(c => ({ ...c, cambio: cambios.get(c.idCita) }))
    }
  },
  async mounted() {
    if (!this.$session.exists()) { this.$router.push('/login'); return }
    try { const { data } = await api.catalogosTodos(4); this.terapeutas = data.datos.terapeuta }
    catch (_) { this.mensaje = 'No fue posible cargar los terapeutas.'; this.error = true }
  },
  methods: {
    estado(c) { return c.cancelada ? 'Cancelada' : c.documentada ? 'Con notas' : c.pasada ? 'Pasada · Solo consulta' : 'Próxima' },
    colorFila(c) { return c.cambio ? 'blue lighten-5' : '' },
    async buscar(pagina = 1) {
      this.buscando = true; this.mensaje = ''; this.paciente = null
      try {
        const { data } = await api.buscarAgenda({ texto: this.texto, pagina })
        if (data.status !== 'ok') throw new Error(data.mensaje)
        this.pacientes = data.datos.pacientes; this.total = data.datos.total; this.pagina = pagina
      } catch (e) { this.mensaje = e.message; this.error = true; this.pacientes = []; this.total = 0 }
      finally { this.buscando = false }
    },
    async abrir(item) {
      this.cargando = item.idPaciente
      try {
        const { data } = await api.historialAgenda(item.idPaciente)
        if (data.status !== 'ok') throw new Error(data.mensaje)
        this.paciente = { idPaciente: data.datos.idPaciente, paciente: data.datos.paciente }; this.citas = data.datos.citas; this.fechaMinima = data.datos.fechaMinima
      } catch (e) { this.mensaje = e.message; this.error = true }
      finally { this.cargando = null }
    },
    seleccionar(item) {
      if (item.pasada || item.cancelada || item.documentada) return
      this.seleccionada = item; this.fecha = item.fecha; this.hora = item.hora.slice(0,5)
      this.terapeuta = item.idTerapeuta; this.invalidar(); this.dialogo = true
    },
    invalidar() { this.vista = []; this.token = ''; this.errorDialogo = '' },
    cancelar() { this.invalidar(); this.dialogo = false },
    async procesar(confirmar) {
      this.guardando = true; this.errorDialogo = ''
      try {
        const { data } = await api.reprogramarAgenda({ idCita: this.seleccionada.idCita, fecha: this.fecha, hora: this.hora, idTerapeuta: this.terapeuta, confirmar, token: this.token })
        if (data.status !== 'ok') throw new Error(data.mensaje)
        if (confirmar) {
          this.dialogo = false; await this.abrir(this.paciente)
          this.mensaje = `${data.datos.cantidad} citas actualizadas correctamente.`; this.error = false
        } else { this.vista = data.datos.cambios; this.token = data.datos.token }
      } catch (e) { this.invalidar(); this.errorDialogo = e.message }
      finally { this.guardando = false }
    }
  }
}
</script>
<style scoped>
/* El historial crece con la página; dentro del diálogo solo se desplaza el cuerpo.
   Evita recortar la tabla mediante dos contenedores de desplazamiento anidados. */
.historial-citas { max-height: none; overflow: visible; }
.reprogramar-dialog-card { display: flex; flex-direction: column; max-height: calc(100vh - 48px); max-height: calc(100dvh - 48px); }
.reprogramar-dialog-title { flex: 0 0 auto; overflow-wrap: anywhere; }
.reprogramar-dialog-body { flex: 1 1 auto; min-height: 0; overflow-y: auto; overscroll-behavior-y: contain; }
.reprogramar-dialog-actions { flex: 0 0 auto; flex-wrap: wrap; gap: 8px; }
</style>
